import { api } from './api.js';

export const importControlAPI = {
  list: async (params = {}) => {
    const response = await api.get('/importControl/list', { params });
    return response.data;
  },

  listMissing: async (params = {}) => {
    const response = await api.get('/importControl/listMissing', { params });
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/importControl/create', data);
    return response.data;
  },

  update: async (data) => {
    const response = await api.post('/importControl/update', data);
    return response.data;
  },

  changeStatus: async (data) => {
    const response = await api.post('/importControl/changeStatus', data);
    return response.data;
  },

  upload: async (formData, config = {}) => {
    const response = await api.post('/importControl/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      ...config
    });
    return response.data;
  },

  reprocessFile: async (id) => {
    const response = await api.post('/importControl/reprocessFile', { importId: id });
    return response.data;
  },

  downloadFile: async (filePathBase64) => {
    const response = await api.get('/importControl/download-file', {
      params: { filePath: filePathBase64 }
      //responseType: 'blob', // Essencial para tratar arquivos binários
    });
    return response; // Retornamos a resposta completa para pegar os dados do blob
  },

  resetProcessFile: async (id) => {
    const response = await api.post('/importControl/resetProcessFile', { importId: id });
    return response.data;
  },


  validateToken: async (data) => {
    const response = await api.post('/importControl/validateToken', data);
    return response.data;
  },

  validateTabTemp: async (data) => {
    const response = await api.post('/importControl/validateTabTemp', data);
    return response.data;
  }
}

